"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseTimeObj = exports.TimeObj = void 0;
const util_1 = require("./util");
class TimeObj {
    hour = 0;
    minute = 0;
    constructor(hour, minute) {
        this.hour = hour;
        this.minute = minute;
    }
    minutesSinceMidnight() {
        return this.hour * 60 + this.minute;
    }
    fmt() {
        const hr = (0, util_1.leftpad)(String(this.hour), 2);
        const min = (0, util_1.leftpad)(String(this.minute), 2);
        return `${hr}:${min}`;
    }
    static create(hour, minute) {
        return new TimeObj(hour, minute);
    }
}
exports.TimeObj = TimeObj;
const parseTimeObj = (stringRaw) => {
    const rawHourMinute = getHourMinute(stringRaw);
    if (!rawHourMinute) {
        return null;
    }
    const [hourRaw, minuteRaw] = rawHourMinute;
    const hour = hourRaw ? Number(hourRaw) : NaN;
    const minute = minuteRaw ? Number(minuteRaw) : NaN;
    if (isNaN(hour) || isNaN(minute)) {
        return null;
    }
    if (hour > 24 || minute > 60) {
        return null;
    }
    if (hour < 0 || minute < 0) {
        return null;
    }
    return new TimeObj(hour % 24, minute);
};
exports.parseTimeObj = parseTimeObj;
const getHourMinute = (stringRaw) => {
    const string = stringRaw?.trim();
    if (!string) {
        return null;
    }
    const colonParts = string.split(':');
    if (colonParts.length > 3) {
        const [hour, minute] = colonParts.slice(0, 2);
        return [hour ?? '', minute ?? ''];
    }
    if (colonParts.length == 2) {
        const [hour, minute] = colonParts;
        return [hour ?? '', minute ?? ''];
    }
    if (string.length == 4) {
        const hour = string.substring(0, 2);
        const minute = string.substring(2);
        return [hour, minute];
    }
    if (string.length == 3) {
        const hour = string.substring(0, 1);
        const minute = string.substring(1);
        return [hour, minute];
    }
    if (string.length == 1 || string.length == 2) {
        return [string, 0];
    }
    return null;
};
//# sourceMappingURL=time.js.map